import { render } from "./CDCDataValuesPage.vue?vue&type=template&id=58d92b77&scoped=true"
import script from "./CDCDataValuesPage.vue?vue&type=script&lang=js"
export * from "./CDCDataValuesPage.vue?vue&type=script&lang=js"

import "./CDCDataValuesPage.vue?vue&type=style&index=0&id=58d92b77&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d92b77"]])

export default __exports__